module.exports = __webpack_public_path__ + "images/bottom_device_bottom.png";